/* eslint-disable */
// This file does nothing. Some builds will update some imports to import this instead

export default new Proxy(
  {},
  {
    get: () => {},
  },
);
